import { post, get, remove, put } from './http';

const getAvailabeCases = async (id) => {
  try {
    return await get(`order-portal/sites/${id}/cases`);
  } catch (err) {
    //   errorHandling(err?.response?.data);
    return err?.response?.data;
  }
};

const AuditCaseReportView = async (data) => {
  try {
    return await post(`order-portal/sites/case-report/audit`, data);
  } catch (err) {
    return err?.response?.data;
  }
};

const AuditCaseReportDownload = async (data) => {
  try {
    return await post(`order-portal/sites/case-report/download/audit`, data).catch(() => {});
  } catch (err) {
    return err?.response?.data;
  }
};

export {
  getAvailabeCases,
  AuditCaseReportView,
  AuditCaseReportDownload
};
